import React from "react"
import { VerticalStack } from "@mallardbay/lib-react-components"

import OutfitterLicensedPill from "~components/pages/outfitter/outfitter-info/outfitter-licensed-pill"
import OutfitterSection from "~components/shared/todo-lib-react-components/outfitter-info/outfitter-section"
import OwnerSection from "~components/shared/todo-lib-react-components/outfitter-info/owner-section"
import Divider from "~components/shared/divider"
import { TEST_IDS } from "~config/test-ids"
import { useCurrentOutfitter } from "~components/providers/current-outfitter-provider"
import ContactSupportBanner from "~components/contact-support-banner"

export default function OutfitterInfoMobile() {
    const { currentOutfitter } = useCurrentOutfitter()

    return (
        <>
            <VerticalStack testId={TEST_IDS.OUTFITTER_INFO_MOBILE}>
                <OutfitterLicensedPill />
                <OutfitterSection
                    outfitter={currentOutfitter}
                    location={currentOutfitter.location!}
                />
                <OwnerSection outfitter={currentOutfitter} />
            </VerticalStack>
            <Divider margin />
            <ContactSupportBanner shouldShowEmail />
        </>
    )
}
